import { render } from "./VacanciesIntro.vue?vue&type=template&id=bd5624a2&scoped=true"
import script from "./VacanciesIntro.vue?vue&type=script&lang=js"
export * from "./VacanciesIntro.vue?vue&type=script&lang=js"

import "./VacanciesIntro.vue?vue&type=style&index=0&id=bd5624a2&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5624a2"]])

export default __exports__